<template>
  <div class="homeReport-list">
    <b-tabs content-class="tabWhite">
      <b-tab active class="results">
        <div class="scrollSection" :style="'height:' + scrollHeight" :class="{mobilescroll : mobWidget == 'Y'}">
          <div style="display:none">
            <!-- <b-row
              v-for="(upC, index) in results.aus[0]"
              :key="index + Math.random()"
              class="rowStyle"
            >
              <a href="https://golf.com.au/pga-tour-aus" class="linkWidth" target="_parent">
                <b-col class="eachItem">
                  <b-nav-item
                    :href="'https://golf.com.au/pga-tour-aus'"
                    target="_parent"
                  >
                    <p class="tourName">
                      {{ upC.short_name }}
                    </p>
                  </b-nav-item>
                  <p  class="tourLink">Tour</p>
                </b-col>
                <b-col>
                  <b-nav-item
                    :href="'https://golf.com.au/pga-tour-aus'"
                    class="angleLink"
                    target="_parent"
                  >
                    <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                  </b-nav-item>
                </b-col>
              </a>
            </b-row> -->
            <!-- <b-row
              v-for="(upC, index) in results.wpg[0]"
              :key="index + Math.random()"
              class="rowStyle"
            >
              <a href="https://golf.com.au/wpga-tour-of-aus" class="linkWidth" target="_parent">
                <b-col class="eachItem">
                  <b-nav-item
                    :href="'https://golf.com.au/wpga-tour-of-aus'"
                    target="_parent"
                  >
                    <p class="tourName">
                      {{ upC.short_name }}
                    </p>
                  </b-nav-item>
                  <p  class="tourLink">WPGA Tour</p>
                </b-col>
                <b-col>
                  <b-nav-item
                    :href="'https://golf.com.au/wpga-tour-of-aus'"
                    class="angleLink"
                    target="_parent"
                  >
                    <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                  </b-nav-item>
                </b-col>
              </a>
            </b-row> -->
            <!-- pro-ams -->
            <!-- <b-row
              v-for="(upC, index) in results.all[0]"
              :key="index + Math.random()"
              class="rowStyle"
            >
              <a href="https://golf.com.au/pga-pro-am-series" class="linkWidth" target="_parent">
                <b-col class="eachItem">
                  <b-nav-item
                    :href="'https://golf.com.au/pga-pro-am-series'"
                    target="_parent"
                  >
                    <p class="tourName">
                      {{ upC.short_name }}
                    </p>
                  </b-nav-item>
                  <p  class="tourLink">Pro-Am</p>
                </b-col>
                <b-col>
                  <b-nav-item
                    :href="'https://golf.com.au/pga-pro-am-series'"
                    class="angleLink"
                    target="_parent"
                  >
                    <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                  </b-nav-item>
                </b-col>
              </a>
            </b-row> -->
            <!-- legends -->
            <!-- <b-row
              v-for="(upC, index) in results.snr[0]"
              :key="index + Math.random()"
              class="rowStyle"
            >
              <a href="https://golf.com.au/pga-legends-tour" class="linkWidth" target="_parent">
                <b-col class="eachItem">
                  <b-nav-item
                    :href="'https://golf.com.au/pga-legends-tour'"
                    target="_parent"
                  >
                    <p class="tourName">
                      {{ upC.short_name }}
                    </p>
                  </b-nav-item>
                  <p  class="tourLink">Legends</p>
                </b-col>
                <b-col>
                  <b-nav-item
                    :href="'https://golf.com.au/pga-legends-tour'"
                    class="angleLink"
                    target="_parent"
                  >
                    <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                  </b-nav-item>
                </b-col>
              </a>
            </b-row> -->
          </div>
          <template v-if="mobWidget == 'Y'">
            <b-row
              v-for="(upC, index) in sortedItems.slice(0,4)"
              :key="index + Math.random()"
              class="rowStyle"
            >
              <template v-if="upC.class_api == 'aus'">
                <a :href="'https://golf.com.au/pga-tour-aus'" class="linkWidth" target="_parent">
                  <b-col class="eachItem" :class="{eachItemScroll : mobWidget == 'Y'}">
                    <b-nav-item
                      :href="'https://golf.com.au/pga-tour-aus'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      Tour
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/pga-tour-aus'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template>
              <!-- <template v-else-if="upC.class_api == 'wpg'">
                <a :href="'https://golf.com.au/wpga-tour-aus'" class="linkWidth" target="_parent">
                  <b-col class="eachItem">
                    <b-nav-item
                      :href="'https://golf.com.au/wpga-tour-aus'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      WPGA Tour
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/wpga-tour-aus'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template> -->
              <template v-else-if="upC.class_api == 'snr'">
                <a :href="'https://golf.com.au/pga-legends-tour'" class="linkWidth" target="_parent">
                  <b-col class="eachItem" :class="{eachItemScroll : mobWidget == 'Y'}">
                    <b-nav-item
                      :href="'https://golf.com.au/pga-legends-tour'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      Legends Tour
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/pga-legends-tour'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template>
              <template v-else>
                <a :href="'https://golf.com.au/pga-pro-am-series'" class="linkWidth" target="_parent">
                  <b-col class="eachItem" :class="{eachItemScroll : mobWidget == 'Y'}">
                    <b-nav-item
                      :href="'https://golf.com.au/pga-pro-am-series'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      Pro Am
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/pga-pro-am-series'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template>
            </b-row>
          </template>
          <template v-else>
            <b-row
              v-for="(upC, index) in sortedItems.slice(0,6)"
              :key="index + Math.random()"
              class="rowStyle"
            >
              <template v-if="upC.class_api == 'aus'">
                <a :href="'https://golf.com.au/pga-tour-aus'" class="linkWidth" target="_parent">
                  <b-col class="eachItem">
                    <b-nav-item
                      :href="'https://golf.com.au/pga-tour-aus'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      Tour
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/pga-tour-aus'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template>
              <!-- <template v-else-if="upC.class_api == 'wpg'">
                <a :href="'https://golf.com.au/wpga-tour-aus'" class="linkWidth" target="_parent">
                  <b-col class="eachItem">
                    <b-nav-item
                      :href="'https://golf.com.au/wpga-tour-aus'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      WPGA Tour
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/wpga-tour-aus'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template> -->
              <template v-else-if="upC.class_api == 'snr'">
                <a :href="'https://golf.com.au/pga-legends-tour'" class="linkWidth" target="_parent">
                  <b-col class="eachItem">
                    <b-nav-item
                      :href="'https://golf.com.au/pga-legends-tour'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      Legends Tour
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/pga-legends-tour'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template>
              <template v-else>
                <a :href="'https://golf.com.au/pga-pro-am-series'" class="linkWidth" target="_parent">
                  <b-col class="eachItem">
                    <b-nav-item
                      :href="'https://golf.com.au/pga-pro-am-series'"
                      target="_parent"
                    >
                      <p class="tourName">
                        {{ upC.short_name }}
                      </p>
                    </b-nav-item>
                    <p class="tourLink">
                      Pro Am
                    </p>
                  </b-col>
                  <b-col>
                    <b-nav-item
                      :href="'https://golf.com.au/pga-pro-am-series'"
                      class="angleLink"
                      target="_parent"
                    >
                      <img class="Rightarrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right.png">
                    </b-nav-item>
                  </b-col>
                </a>
              </template>
            </b-row>
          </template>
        </div>
        <!-- lower links -->
        <b-row>
          <b-col cols="1">
          </b-col>
          <b-col cols="11" class="nopadRight">
            <b-row class="linktourRow">
              <b-col class="upPadRight">
                <b-nav-item
                  class="LinkReport"
                  :href="'https://golf.com.au/pga-tour-aus'"
                  target="_parent"
                >
                  <p class="quickLink">
                    PGATA
                    <img class="rightLittleArrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right-copy.png">
                  </p>
                </b-nav-item>
              </b-col>
              <!-- <b-col class="upPadRight">
                <b-nav-item
                  class="LinkReport"
                  :href="'https://golf.com.au/wpga-tour-aus'"
                  target="_parent"
                >
                  <p class="quickLink">
                    WPGA
                    <img class="rightLittleArrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right-copy.png">
                  </p>
                </b-nav-item>
              </b-col> -->
              <b-col class="upPadRight">
                <b-nav-item
                  class="LinkReport"
                  :href="'https://golf.com.au/pga-legends-tour'"
                  target="_parent"
                >
                  <p class="quickLink">
                    Legends
                    <img class="rightLittleArrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right-copy.png">
                  </p>
                </b-nav-item>
              </b-col>
              <b-col>
                <b-nav-item
                  class="LinkReport"
                  :href="'https://golf.com.au/pga-pro-am-series'"
                  target="_parent"
                >
                  <p class="quickLink">
                    Pro-Am
                    <img class="rightLittleArrow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/07/chevron-right-copy.png">
                  </p>
                </b-nav-item>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import axios from "axios";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import _ from 'lodash'
export default {
  name: "homeReportSelect",
  props: ["season"],
  componentss: [
    lodash,
    VueLodash,
    _,
  ],
  data() {
    return {
      results: [],
      tm_params: [],
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      text: '',
      scrollHeight: '',
      allUp: ''
    };
  },
  methods: {
    myFunction: function() {
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
      if (this.text == 1400 || this.text > 1401) {
        if (this.mobWidget == 'Y') {
          this.scrollHeight = '280px!important'
        } else {
          this.scrollHeight = '472px!important' 
        }
        // this.scrollHeight = '555px!important'
      } else if(this.text < 1400  && this.text > 1200) {
        // this.scrollHeight = '442px!important'
        this.scrollHeight = '383px!important'
      } else if(this.text > 990 && this.text < 1199) {
        // this.scrollHeight = '357px!important'
        this.scrollHeight = '320px!important'
      }
    },
  },
  created() {
    this.myFunction();
    window.addEventListener('resize', this.myFunction);
  },
  computed: {
    sortedItems: function() {
      return _.orderBy(this.allUp, 'days_away')
    }
  },
  mounted() {
    axios
      .get(
        process.env.VUE_APP_TIC_BASE+process.env.VUE_APP_AUS+"/tmticx?field=Y&fields=code&fields=tm_params.season_code&fields=ts_final_result&fields=scores_available&fields=entries_avail&fields=reports.reports_entry&randomadd=" +
          new Date().getTime()
      )
      .then((response) => {
        (this.tm_params = response.data), (this.id = response.data);
        return axios.get(

          // 'https://api.aus.ocs-software.com/pgaaus/cache/aus/2024/tmticx?multi=Y&res=Y&tour=snr&tour=aus&tour=all&field=Y&fields=tournaments.tournaments_entry&randomadd=1721747260092'

          "https://api.aus.ocs-software.com/pgaaus/cache/aus/" +
            this.tm_params.tm_params.season_code +
            "/tmticx?multi=Y&res=Y&tour=snr&tour=aus&tour=all&field=Y&fields=tournaments.tournaments_entry&randomadd=" +
            new Date().getTime()
        );
      })
      .then((response) => {
        this.results = response.data;
          const children = this.results.aus[0].concat(this.results.snr[0], this.results.all[0]); 
          this.allUp = children
          console.log("this.allUp Full")
          console.log(this.allUp)
        // if (response.data.wpg[0] == null) {
        //   const children = this.results.aus[0].concat(this.results.snr[0], this.results.all[0]); 
        //   this.allUp = children
        //   console.log("this.allUp WPGA")
        //   console.log(this.allUp)
        // } else if(response.data.snr[0] == null) {
        //   const children = this.results.aus[0].concat(this.results.all[0], this.results.wpg[0]); 
        //   this.allUp = children
        //   console.log("this.allUp SNR")
        //   console.log(this.allUp)
        // } else if(response.data.aus[0] == null) {
        //   const children = this.results.snr[0].concat(this.results.all[0], this.results.wpg[0]); 
        //   this.allUp = children
        //   console.log("this.allUp AUS")
        //   console.log(this.allUp)
        // } else if(response.data.all[0] == null) {
        //   const children = this.results.aus[0].concat(this.results.snr[0], this.results.wpg[0]); 
        //   this.allUp = children
        //   console.log("this.allUp all ALL")
        //   console.log(this.allUp)    
        // } else {
        //   const children = this.results.aus[0].concat(this.results.snr[0], this.results.all[0], this.results.wpg[0]); 
        //   this.allUp = children
        //   console.log("this.allUp Full")
        //   console.log(this.allUp)
        // }

      });
  },
};
</script>

<style scoped>
.scrollSection {
  overflow: hidden;
  height: 555px;
  overflow-x: hidden;
}
.scrollSection::-webkit-scrollbar {
  display: none; 
}
.scrollSection {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.upPadRight.col {
  padding-right: 0;
}
.nopadRight {
  padding-right: 0;
}
a.linkWidth {
  width: 100%;
  display: inline-flex;
}
a.linkWidth:hover {
  text-decoration: none;
}
img.rightLittleArrow {
  margin-left: 5px;
  margin-top: -1px;
}
img.Rightarrow {
  float: right;
  /* margin-right: 40px; */
  margin-top: 23px;
}
li.nav-item.angleLink > a {
  padding: 0;
  color: #000000!important;
}
svg.iconLink.svg-inline--fa.fa-angle-right.fa-w-8 {
  /* height: 58px; */
  width: 23px;
  float: right;
  margin-right: 30px;
  margin-top: 25px;
}
.rowStyle {
  border-bottom: 1px solid #00000033;
}
::v-deep .nav-tabs .nav-link:hover {
  display: none;
}
::v-deep .nav-tabs .nav-link.active {
  display: none;
}
::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #e6e6e6;
  color: #00433e !important;
  border-bottom-color: transparent;
  border-radius: 3px 3px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 600;
  font-style: normal;
  font-size: 9pt;
}
li {
  list-style-type: none;
}
.quickLink {
  color: #003C52;
  font-size: 14px;
  font-weight: 600;
}

::v-deep .nav-item > a {
  color: white;
}
::v-deep .eachItem > li > a {
  padding-left: 0px;
  padding-bottom: 2px;
  padding-top: 25px;
}
.tourName {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  line-height: 0;
  padding-left: 0px;
  margin-bottom: 5px;
}

.tourLink {
  font-size: 12px;
  color: #003C52;
  font-weight: 600;
  display: block;
  line-height: 26px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* border-bottom: 1px solid #00000033; */
}
::v-deep .tourLink:hover {
  font-size: 12px;
  color: #003C52;
  font-weight: 600;
  display: block;
  line-height: 26px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* border-bottom: 1px solid #00000033; */
}
::v-deep .tab-content {
  background-color: white;
}
::v-deep .tabWhite {
  padding-top: 0em;
  height: 581px;
  padding-left: 20px;
  padding-right: 20px;
}
.eachItem {
  /* padding: 0px 30px; */
  min-width: 70%;
}
::v-deep li.nav-item.LinkReport > a.nav-link {
  padding-left: 15px;
  padding: 0;
}
::v-deep li.nav-item.LinkReport {
  text-align: right;
}
.linktourRow {
  margin: auto;
  /* padding-top: 25px; */
  padding-top: 9px;
  margin-right: 10px;
}
.mobilescroll {
  overflow: scroll;
  height: 280px!important;
}
.eachItemScroll>li>a {
  padding-top: 11px!important;
}

@media only screen and (max-width: 1400px) {
  .eachItem {
    min-width: 85%;
  }
  img.rightLittleArrow {
    margin-left: 0px;
    position: absolute;
    top: 7px;
    padding-left: 6px;
  }
  .tabWhite {
    padding-top: 0;
    height: 181px!important;
  }
}
@media only screen and (max-width: 1200px) {
  .tourName {
      font-size: 14px;
      font-weight: 600;
      color: #000;
      line-height: .9;
      padding-left: 0;
      margin-bottom: 5px;
  }
}
@media only screen and (max-width: 1024px) {
  ::v-deep .tabWhite {
    padding-top: 0em;
    height: inherit!important;
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media only screen and (max-width: 400px) {
  .linktourRow {
    margin: auto;
    padding-top: 20px;
    margin-right: -6px;
    padding-right: 16px;
  }
  .eachItem>li>a {
    padding-left: 0;
    padding-bottom: 2px;
    padding-top: 18px;
  }
}
@media only screen and (max-width: 321px) {
  .eachItem>li>a {
      padding-left: 0;
      padding-bottom: 2px;
      padding-top: 10px;
  }
  .eachItem>li>a:first-child {
      padding-left: 0;
      padding-bottom: 2px;
      padding-top: 13px;
  }
  .linktourRow {
    margin: auto;
    padding-top: 20px;
    margin-right: -12px;
    padding-right: 0px;
  }
}
</style>